$(document).ready(function(){
    $('.header-top .navigation-buttons').append('<a href="/oblibene/" data-target="oblibene"><span>Oblíbené</span><i></i></a>')
   // oblibene_length = JSON.parse(localStorage.getItem('favorite_product')).length
    if(JSON.parse(localStorage.getItem('favorite_product')) !== null){
        $('a[data-target="oblibene"]').addClass('have-favorite')
        if(JSON.parse(localStorage.getItem('favorite_product')).length<1){
            $('a[data-target="oblibene"]').removeClass('have-favorite').find('i').text(0)
        }
    }
    else{
        $('a[data-target="oblibene"]').removeClass('have-favorite')
      
    }
    var fav_enteries = JSON.parse(localStorage.getItem('favorite_product'));
    if(fav_enteries == null) fav_enteries = [];
    if($('.type-detail').length){
        code = $('.p-data-wrapper').find('meta[itemprop="sku"]').attr('content')
        for (var i = 0; i < fav_enteries.length; i++) {
            if (fav_enteries[i].code == code) {
                theIndex = i;
                $('.oblibene-button').addClass('active-favorite');
                $('a[data-target="oblibene"]').find('i').text(fav_enteries.length);
                break;
            }
        }
    }
    $('.product').each(function() {
        $(this).find('.p').append('<span class="favorite"></span>')
        var code = $(this).find('span[data-micro="sku"]').text();
        var theIndex = -1;
        for (var i = 0; i < fav_enteries.length; i++) { // search if product ID already in localstorage
            if (fav_enteries[i].code == code) {
                theIndex = i;
                $(this).addClass('active-favorite');
                $('a[data-target="oblibene"]').find('i').text(fav_enteries.length);
                break;
            }
        }
    })
    $('html').on('click', '.products .product .favorite', function(e){
        $(this).closest('.product').toggleClass('active-favorite')
        closest = e.target.closest('.product')
        code = $(closest).find('span[data-micro="sku"]').text()
        add_to_local()
       
    }) 
    $('html').on('click', '.p-data-wrapper .oblibene-button', function(e){
        $(this).toggleClass('active-favorite')
        closest = e.target.closest('.p-data-wrapper')
        code = $(closest).find('meta[itemprop="sku"]').attr('content')
        add_to_local()
        
    }) 
});
  
if($('.in-oblibene').length){
    if(JSON.parse(localStorage.getItem("favorite_product"))) {
          var fav_array = JSON.parse(localStorage.getItem("favorite_product"));
       } else {
          fav_array = "";
       }
      
       if(fav_array.length>0) {
          $('div[itemprop="about"]').append('<div id="products" class="fav-products products products-page products-block"></div>')
          for (var i = 0; i < fav_array.length; i++) {
            var favorite_product = '<div class="product">'
            favorite_product += '<div class="p">'
            favorite_product += '<a href="'+fav_array[i].link+'" class="image"><img src="'+fav_array[i].image+'">'
        
            if(typeof(fav_array[i].flags_default) !== 'undefined'){
                favorite_product += '<div class="flags flags-default">'+fav_array[i].flags_default+'</div>'
            }
            if(typeof(fav_array[i].flags_extra) !== 'undefined'){
                favorite_product += '<div class="flags flags-extra">'+fav_array[i].flags_extra+'</div>'
            }
            favorite_product += '</a>'
            favorite_product += '<div class="p-in">'
            favorite_product += '<div class="p-in-in">'
            favorite_product += '<a href="'+fav_array[i].link+'" class="name"><span data-micro="name" data-testid="productCardName">'+fav_array[i].title+'</span></a>'
            favorite_product += '</div>'
            favorite_product += '<div class="p-bottom">'
            favorite_product += '<div>'
            favorite_product += '<div class="prices">'
            favorite_product += '<div class="price price-final" data-testid="productCardPrice"><strong>'+fav_array[i].price+'</strong></div>'
            if(typeof(fav_array[i].price_sale) !== 'undefined'){
                favorite_product += '<span class="price-standard"><span><strong>'+fav_array[i].price_sale+'</strong></span></span>'
            }
            favorite_product += '</div>'
            favorite_product += '<div class="p-tools">'
            if(typeof(fav_array[i].button) !== 'undefined'){
                favorite_product += fav_array[i].button
            }
            
            favorite_product += '</div>'
            favorite_product += '</div>'
            favorite_product += '</div>'
            favorite_product += '</div>'
            favorite_product += '<span class="no-display" data-micro="sku">'+fav_array[i].code+'</span>'
            favorite_product += '</div>'
            favorite_product += '</div>'
            $(".fav-products").append(favorite_product)
          }
          $('body').on("click", '.favorite', function(){
              $(this).closest('.product').remove();
              code = $(this).closest('.product').find('span[data-micro="sku"]').text()
              console.log(JSON.parse(localStorage.getItem("favorite_product")).length)
              setTimeout(function(){
                if(JSON.parse(localStorage.getItem("favorite_product")).length<1){
                    $('div[itemprop="about"]').append('<h2>Prozatím nemáte žádné oblíbené produkty</h2>')
                  }
              }, 100)
              add_to_local()
          })
        }
        else{
            $('div[itemprop="about"]').append('<h2>Prozatím nemáte žádné oblíbené produkty</h2>')
        }
}


function add_to_local(){
    if(window.localStorage!==undefined) {
        var exist_fav_products = JSON.parse(localStorage.getItem('favorite_product'));
        if(exist_fav_products == null) exist_fav_products = [];
        var theIndex = -1;
        for (var i = 0; i < exist_fav_products.length; i++) {
           if (exist_fav_products[i].code == code) {
          var idToRemove= exist_fav_products[i].code;
              theIndex = i;
              break;
           }
        }
        if (theIndex == -1){
            var date = new Date();
            date.setTime(date.getTime());
            var date_product = date.toGMTString();
            if($('.type-detail').length){
                var entry_detail = {
                    "code": $(closest).find('meta[itemprop="sku"]').attr('content'),
                    "title": $(closest).find('.p-detail-inner-header h1').text().trim(),
                    "image": $('.p-image-wrapper #wrap a').attr('href').replace('/big/', '/detail/'),
                    "link": document.location.pathname,
                    "date": date_product, 
                    "flags_default": $('.p-image').find('.flags-default').html(),
                    "flags_extra": $('.p-image').find('.flags-extra').html(),
                    "price_sale": $(closest).find('.p-final-price-wrapper .price-standard span:not(".noDisplay")').text(),
                    "price": $(closest).find('.p-final-price-wrapper .price-final').html(),
                    "button": '<a href="'+document.location.pathname+'" class="btn btn-primary">Detail</a>'
                }
            }
            else{
                var entry = {
                    "code": $(closest).find('span[data-micro="sku"]').text(),
                    "title": $(closest).find('a.name').text().trim(),
                    "image": $(closest).find('.image img').attr('data-src'),
                    "link": $(closest).find('.image').attr('href'),
                    "date": date_product, 
                    "flags_default": $(closest).find('.image .flags-default').html(),
                    "flags_extra": $(closest).find('.image .flags-extra').html(),
                    "price": $(closest).find('.price-final strong').text(),
                    "price_sale": $(closest).find('.price-standard strong').text(),
                    "button": $(closest).find('.p-tools').html()

                }
            }
                if($('.type-detail').length){
                    exist_fav_products.push(entry_detail);
                }
                else{
                    exist_fav_products.push(entry);
                }
                

            var sorting_fav = exist_fav_products.sort(function compare(a, b) {
                var dateA = new Date(a.date);
                var dateB = new Date(b.date);
                return dateB - dateA;
            });
            if(Object.keys(sorting_fav).length === 50) sorting_fav.pop();
            localStorage.setItem('favorite_product', JSON.stringify(sorting_fav));
        } else {
            var removeIndex = exist_fav_products.map(function(item) { return item.code; }).indexOf(idToRemove);
            exist_fav_products.splice(removeIndex,1);
            localStorage.setItem('favorite_product', JSON.stringify(exist_fav_products));
        }
        oblibene_length = JSON.parse(localStorage.getItem('favorite_product')).length
        if(oblibene_length>0){
        $('a[data-target="oblibene"]').addClass('have-favorite')
        $('a[data-target="oblibene"]').find('i').text(oblibene_length);
       }
       else{
        $('a[data-target="oblibene"]').removeClass('have-favorite')
     
       }

        
    }
}